// @ts-nocheck
// @ts-ignore
class CustomCartWishlist {
  constructor(headerWishlistCountSpan, wishlistContainer, emptyStateDiv) {
    this.headerWishlistCountSpan = headerWishlistCountSpan;
    this.wishlistContainer = wishlistContainer;
    this.emptyStateDiv = emptyStateDiv;

    const cache = (globalThis.wishlistItemsSTC && typeof globalThis.wishlistItemsSTC === 'object')
      ? globalThis.wishlistItemsSTC
      : null;
    const cachedItems = cache?.items;

    this.loading = true;
    this.state = (Array.isArray(cachedItems) && cachedItems.length > 0)
      ? { items: cachedItems, count: cache?.count ?? cachedItems.length }
      : { items: [], count: 0 };
    this.productIds = Array.isArray(cache?.productIds) ? cache.productIds : [];
    this.extraData = Array.isArray(cache?.extraData) ? cache.extraData : [];

    // this.init("Constructor");
  }

  /**
   * Shared wishlist cache across sections.
   * @returns {{items?: any[], count?: number, extraData?: any[], productIds?: any[], fetchedAt?: number, source?: string} | null}
   */
  getWishlistCache() {
    const cache = globalThis.wishlistItemsSTC;
    if (!cache || typeof cache !== 'object') return null;
    return cache;
  }

  /**
   * @param {{items?: any[], count?: number, extraData?: any[], productIds?: any[], fetchedAt?: number, source?: string}} data
   */
  setWishlistCache(data) {
    globalThis.wishlistItemsSTC = {
      ...(globalThis.wishlistItemsSTC && typeof globalThis.wishlistItemsSTC === 'object' ? globalThis.wishlistItemsSTC : {}),
      ...data,
      fetchedAt: Date.now(),
      source: data.source || 'custom-cart-wishlist',

    };
  }

  /** Storefront credentials for wishlist card metafields (highlights / tag). */
  getWishlistMetafieldsConfig() {
    return {
      storefrontAccessToken: window.storefrontAccessToken,
      shopDomain: window.storeDomain,
    };
  }

  /**
   * Load metafields for current productIds (used for card highlights/tag).
   * Call this when wishlist items come from cache so cards still hydrate correctly.
   */
  async fetchWishlistCardMetafields() {
    if (!Array.isArray(this.productIds) || this.productIds.length === 0) return;
    this.extraData = await this.fetchProductMetafields({
      productIds: this.productIds,
      ...this.getWishlistMetafieldsConfig(),
    });
    this.setWishlistCache({
      extraData: this.extraData,
      productIds: this.productIds,
      source: 'custom-cart-wishlist-extraData',
    });
  }

  async init(invoker) {
    // Reset state on every init (important for cart drawer reopen)
    this.loading = true;
    this.state = { items: [], count: 0 };
    this.productIds = [];
    this.extraData = [];

    // Show loading skeleton and hide empty state until fetch completes
    const loadingEl = this.wishlistContainer.querySelector('[data-wishlist-loading]');
    if (loadingEl) loadingEl.classList.remove('is-hidden');
    if (this.emptyStateDiv) this.emptyStateDiv.classList.add('is-hidden');

    // Re-query count span so we always update the current in-DOM node (fixes stale ref after drawer re-render)
    const currentSpan = document.querySelector('[data-wishlist-count]');
    if (currentSpan) this.headerWishlistCountSpan = currentSpan;

    const run = async (invoker) => {
      try {
        const cache = this.getWishlistCache();
        const cachedItems = cache?.items;
        const cachedExtra = cache?.extraData;

        // Use cache for wishlist items (no /a/wishlist call), but still fetch metafields for cards.
        if (Array.isArray(cachedItems) && cachedItems.length > 0) {
          this.state = { ...(this.state || {}), items: cachedItems, count: cache?.count ?? cachedItems.length };
          this.productIds = Array.isArray(cache?.productIds) && cache.productIds.length > 0
            ? cache.productIds
            : this.getProductIds(cachedItems);
          this.extraData = Array.isArray(cachedExtra) ? cachedExtra : [];
          await this.fetchWishlistCardMetafields();
        } else {
          await this.fetchWishlistItems();
        }

        this.latestWishlistItems = false;
        this.updateHeaderWishlistCount("Run");
        this.hydrateWishlistContainer();
      } catch (error) {
        console.error('Error in wishlist init:', error);
        const loadingEl = this.wishlistContainer.querySelector('[data-wishlist-loading]');
        if (loadingEl) loadingEl.classList.add('is-hidden');
        if (this.emptyStateDiv) this.emptyStateDiv.classList.remove('is-hidden');
      } finally {
        this.loading = false;
      }
    };

    // If cache is empty, ensure SmartWishlist SDK is ready before fetching.
    const cache = this.getWishlistCache();
    if (cache?.forceEmpty === true) {
      // Another component already confirmed wishlist is empty; don't refetch.
      this.state = { items: [], count: 0 };
      this.productIds = [];
      this.extraData = [];
      this.updateHeaderWishlistCount("Cache");
      this.hydrateWishlistContainer();
      this.loading = false;
      return;
    }
    const hasCacheItems = Array.isArray(cache?.items) && cache.items.length > 0;
    if (!hasCacheItems && typeof waitForWishlistSDKAndCallMyFunction === 'function') {
      waitForWishlistSDKAndCallMyFunction(() => {
        run("WaitForWishlistSDK");
      });
      return;
    }

    await run("Run");
  }

  /*
  * Fetch wishlist items from API
  * @returns {Promise<void>}
  */
  async fetchWishlistItems() {
    // Guard: if cache already has items, skip fetching entirely.
    const cache = this.getWishlistCache();
    if (Array.isArray(cache?.items) && cache.items.length > 0) {
      this.state = { items: cache.items, count: cache.count ?? cache.items.length };
      this.productIds = Array.isArray(cache.productIds) && cache.productIds.length > 0
        ? cache.productIds
        : this.getProductIds(cache.items);
      this.extraData = Array.isArray(cache.extraData) ? cache.extraData : [];
      await this.fetchWishlistCardMetafields();
      return;
    }
    try {
      // Check if SDK functions are available
      if (typeof SWGetCustomerWishlistId !== 'function' || typeof SWGetExpressWishlistId !== 'function') {
        console.warn('SmartWishlist SDK functions not available');
        return;
      }

      const customerId = SWGetCustomerWishlistId(); // 0 if not logged in
      const wishlistId = SWGetExpressWishlistId();

      if (customerId === 0) {
        // Non logged-in user
        this.state = await this.getData('wishlistid', wishlistId);
        this.productIds = this.getProductIds(this.state.items || []);
        this.extraData = await this.fetchProductMetafields({
          productIds: this.productIds,
          ...this.getWishlistMetafieldsConfig(),
        });
        this.setWishlistCache({ items: this.state.items, count: this.state.count, productIds: this.productIds, extraData: this.extraData });

      } else {
        // Logged-in user
        this.state = await this.getData('customerid', customerId);
        this.productIds = this.getProductIds(this.state.items || []);
        this.extraData = await this.fetchProductMetafields({
          productIds: this.productIds,
          ...this.getWishlistMetafieldsConfig(),
        });
        this.setWishlistCache({ items: this.state.items, count: this.state.count, productIds: this.productIds, extraData: this.extraData });
      }
    } catch (error) {
      console.error('Error in fetchWishlistItems:', error);
      throw error;
    }
  }

  /**
   * Update wishlist tab label: "WISHLIST" only when count is 0, "WISHLIST [N ITEM(s)]" when count > 0.
   * @param {number} count
   */
  updateWishlistTabDisplay(count = 0, invoker) {
    const countSpan = document.querySelector('[data-wishlist-count]');
    const itemTextSpan = document.querySelector('[data-wishlist-item-text]');
    const wrapper = document.querySelector('[data-wishlist-count-wrapper]');
    const n = Number(count) || 0;
    if (countSpan) countSpan.textContent = n;
    if (itemTextSpan) itemTextSpan.textContent = n === 1 ? 'ITEM' : 'ITEMS';
    if (wrapper) wrapper.style.display = n > 0 ? '' : 'none';
  }

  // Update header wishlist count (and tab label: show bracket only when count > 0)
  updateHeaderWishlistCount(invoker) {
    const cache = this.getWishlistCache();
    const fromState = this.state && this.state.count != null ? Number(this.state.count) : null;
    const fromCache = cache && cache.count != null ? Number(cache.count) : null;
    const fromItems = Array.isArray(cache?.items) ? cache.items.length : 0;
    const count = Number.isFinite(fromState) ? fromState
      : (Number.isFinite(fromCache) ? fromCache : fromItems);
    this.updateWishlistTabDisplay(count, invoker);
  }

  /**
   * Checks if SmartWishlist SDK is loaded
   * @returns {boolean} True if SDK is available
   */
  isSDKLoaded() {
    return typeof SWGetCustomerWishlistId === 'function' && typeof ReloadSmartWishlist === 'function';
  }

  /**
   * Sets up click event listeners on all .fa-heart icons
   * Should be called after SDK has activated the wishlist buttons
   */
  setupHeartIconClickListeners() {
    // Use a small delay to ensure SDK has fully rendered the heart icons
    setTimeout(() => {

      document.querySelectorAll(".fa-heart").forEach(h => {
        h.addEventListener("click", async (e) => {
          // delay on butotn click -> SDK API and our click event clash causes data missmatch.
          let prevCount = Number(document.querySelector('[data-wishlist-count]')?.textContent) || 0;
          if (prevCount > 0) this.updateWishlistTabDisplay(prevCount - 1);
          const wishlistButton = e.target.closest(".wishlistcardButton");
          if (wishlistButton && wishlistButton.dataset.product) {
            // Show loader on card level for wishlist tab
            let cardLoader = e.target?.closest(".card_wishlist")?.querySelector(".wishlist-loader");
            if (cardLoader) {
              cardLoader.classList.remove("wishlist-loader-hide");
            }

            try {
              // re fetch wishlist items
              await this.fetchWishlistItems();
            } catch (error) {
              console.error('Error fetching wishlist items:', error);
              // Continue execution even if fetch fails to update UI with current state
            } finally {
              // Always hide loader and update UI regardless of success/failure
              if (cardLoader) {
                cardLoader.classList.add("wishlist-loader-hide");
              }
              this.loading = false;
              this.updateHeaderWishlistCount(0, `Heart Remove ${h}`);
              this.hydrateWishlistContainer();
              if(typeof document.querySelector('custom-from-your-wishlist')?.reset() === 'function'){
                document.querySelector('custom-from-your-wishlist')?.reset()
              }
            }
          }
        });
      });

      document.querySelectorAll(".fa-heart-o").forEach(h => {
        h.addEventListener("click", async (e) => {
          let prevCount = Number(document.querySelector('[data-wishlist-count]')?.textContent) || 0;
          this.updateWishlistTabDisplay(prevCount + 1);
          const wishlistButton = e.target.closest(".wishlistcardButton");

          if (wishlistButton && wishlistButton.dataset.product) {
            // Show loader on card level for wishlist tab
            let cardLoader = e.target?.closest(".card_wishlist")?.querySelector(".wishlist-loader");
            if (cardLoader) {
              cardLoader.classList.remove("wishlist-loader-hide");
            }

            try {
              await this.fetchWishlistItems();
            } catch (error) {
              console.error('Error fetching wishlist items:', error);
              // Continue execution even if fetch fails to update UI with current state
            } finally {
              // Always hide loader and update UI regardless of success/failure
              if (cardLoader) {
                cardLoader.classList.add("wishlist-loader-hide");
              }
              this.loading = false;
              this.updateHeaderWishlistCount(0, `Heart Remove ${h}`);
              this.hydrateWishlistContainer();
              if(typeof document.querySelector('custom-from-your-wishlist')?.reset() === 'function'){
                document.querySelector('custom-from-your-wishlist')?.reset()
              }
            }
          }
        });
      });
    }, 100); // Small delay to ensure icons are rendered
  }

  hydrateWishlistContainer() {
    try {
      // Hide loading skeleton now that we have data to show
      const loadingEl = this.wishlistContainer.querySelector('[data-wishlist-loading]');
      if (loadingEl) loadingEl.classList.add('is-hidden');

      const wishlistGrid = this.wishlistContainer.querySelector('[data-wishlist-grid]');
      if (!wishlistGrid) return;

      wishlistGrid.innerHTML = '';

      if (this.state.count && this.state.items?.length) {
        if (this.emptyStateDiv) this.emptyStateDiv.classList.add('is-hidden');

        const fragment = document.createDocumentFragment();
        this.state.items.forEach((product, index) => {
          try {
            let productCard = this.createProductCard(product);
            let highlightsElement = productCard.querySelector(".wishlist-product-card__highlights");
            let tagElement = productCard.querySelector(".wishlist-product-card__tag");

            // Safely access extraData with fallback
            const extraDataItem = this.extraData && Array.isArray(this.extraData) && this.extraData[index]
              ? this.extraData[index]
              : { highlights: [], tag: "" };

            this.hydrateHighlights(extraDataItem.highlights || [], highlightsElement);
            this.hydrateTag(extraDataItem.tag || "", tagElement);
            fragment.appendChild(productCard);
          } catch (error) {
            console.error(`Error creating product card for index ${index}:`, error);
            // Continue with next item even if one fails
          }
        });

        wishlistGrid.appendChild(fragment);

      // Call ReloadSmartWishlist() only after grid is hydrated and SDK is loaded
      // Use setTimeout to ensure DOM is fully updated
      setTimeout(() => {
        const productCards = wishlistGrid.querySelectorAll('.wishlist-product-card');
        if (productCards.length > 0 && this.isSDKLoaded()) {
          if (typeof ReloadSmartWishlist === 'function') {
            ReloadSmartWishlist();

            // Update font sizes for heart icons
            const wishlistGridElement = document.querySelector(".wishlist-products__grid");
            if (wishlistGridElement) {
              wishlistGridElement.querySelectorAll(".fa-heart").forEach((h) => {
                h.style.fontSize = "18px";
              });
            }

            // Set up click event listeners on heart icons after they're activated
            // this.setupHeartIconClickListeners();
          }
        }
      }, 0);
      } else {
        if (this.emptyStateDiv) this.emptyStateDiv.classList.remove('is-hidden');
      }
    } catch (error) {
      console.error('Error in hydrateWishlistContainer:', error);
      // Hide loading and show empty state on error
      const loadingEl = this.wishlistContainer.querySelector('[data-wishlist-loading]');
      if (loadingEl) loadingEl.classList.add('is-hidden');
      if (this.emptyStateDiv) {
        this.emptyStateDiv.classList.remove('is-hidden');
      }
    }
  }

  // Creates product card
  createProductCard(product) {
    const productCard = document.createElement('div');
    productCard.classList.add('wishlist-product-card');

    const price = parseFloat(product.variant_price || 0);
    const formattedPrice = `₹ ${price.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
    const title = product.title;
    // let highlights =

    productCard.innerHTML = `
      <div class="wishlist-product-card__content">
        <div class="wishlist-product-card__header">
          <div class="wishlist-product-card__header-text-content">
            <a href="/products/${product.handle}" class="wishlist-product-card__title athletics-semibold">${title}</a>
            <a href="/products/${product.handle}" class="wishlist-product-card__highlights athletics-regular"></a>
          </div>
          <div class="card_wishlist">
            <div class="card_wishLogo"></div>
            <span
              class="smartwishlist wishlistcardButton card_wishlist-custom-cart__wishlist-tab"
              data-product="${product.id}"
              data-variant="${product.variant_id}">
            </span>
            <div class="wishlist-loader wishlist-loader-hide">
              <custom-cart-loader></custom-cart-loader>
            </div>
          </div>
        </div>

        <div class="wishlist-product-card__body">
          <a href="/products/${product.handle}" class="wishlist-product-card__body-image-wrapper">
            <div class="wishlist-product-card__tag athletics-medium">Ideal for Training</div>
            <img src="${product.image}&width=320" alt="${title}" class="wishlist-product-card__image" loading="lazy">
          </a>

          <div class="atc-link-button-wrapper cursor-pointer" onclick="ATBModalOpen(event, '${product.id}');
                document.querySelector('cart-drawer-component').close();">
        <span class="atc-link-button">
            <!-- Top Left -->
            <span class="atc-link-button__corner atc-link-button__corner--tl">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <mask id="corner-mask-tl" fill="white">
                        <path
                            d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
                    </mask>
                    <path
                        d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z"
                        fill="#ffffff" mask="url(#corner-mask-tl)" />
                </svg>
            </span>

            <!-- Top Right -->
            <span class="atc-link-button__corner atc-link-button__corner--tr">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <mask id="corner-mask-tl" fill="white">
                        <path
                            d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
                    </mask>
                    <path
                        d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z"
                        fill="#ffffff" mask="url(#corner-mask-tl)" />
                </svg>
            </span>

            <!-- Bottom Left -->
            <span class="atc-link-button__corner atc-link-button__corner--bl">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <mask id="corner-mask-tl" fill="white">
                        <path
                            d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
                    </mask>
                    <path
                        d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z"
                        fill="#ffffff" mask="url(#corner-mask-tl)" />
                </svg>
            </span>

            <!-- Bottom Right -->
            <span class="atc-link-button__corner atc-link-button__corner--br">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <mask id="corner-mask-tl" fill="white">
                        <path
                            d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
                    </mask>
                    <path
                        d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z"
                        fill="#ffffff" mask="url(#corner-mask-tl)" />
                </svg>
            </span>

            <span class="atc-link-button__text">${formattedPrice} |  + Add to Cart</span>
        </span>
    </div>
        </div>
      </div>
    `


    const wlButton = productCard.querySelector(".smartwishlist");
    wlButton.addEventListener("click", (e) => {
      const productId = e.target.closest('[data-product]').getAttribute('data-product');

      const prevCache = (globalThis.wishlistItemsSTC && typeof globalThis.wishlistItemsSTC === 'object')
        ? globalThis.wishlistItemsSTC
        : { items: [], count: 0 };

      const nextItems = Array.isArray(prevCache.items)
        ? prevCache.items.filter((item) => String(item?.id) !== String(productId))
        : [];

      const nextCount = nextItems.length;

      globalThis.wishlistItemsSTC = {
        ...prevCache,
        source: 'smartwishlist-click-update',
        items: nextItems,
        count: nextCount,
        fetchedAt: Date.now(),
        forceEmpty: Array.isArray(nextItems) ? nextItems.length === 0 : false,
      }
      document.querySelector('custom-from-your-wishlist')?.reset()
        this.updateWishlistTabDisplay(nextCount, `Heart Remove`);
        productCard.remove();
        if(globalThis.wishlistItemsSTC?.forceEmpty === true){
          document.querySelector('[data-wishlist-empty]').classList.remove('is-hidden');
        }
    });

    return productCard;
  }

  // Fetch wishlist items from API
  async getData(type, id) {
    try {
      this.loading = true;

      const response = await fetch(`/a/wishlist?type=api&${type}=${id}&version=1`);
      return await response.json();
    } catch (error) {
      console.warn('Error fetching wishlist items:', error);
      return {};
    } finally {
      this.loading = false;
    }
  }

  // Extract product ids from wishlist items
  getProductIds(items) {
    return items.map(item => item.id);
  }

  /**
   * Fetch metafields (highlights + tag) for variants
   * Response order strictly matches productIds order
   */
  async fetchProductMetafields({productIds, storefrontAccessToken, shopDomain}) {
    try {
      // Return empty array if no product IDs
      if (!Array.isArray(productIds) || productIds.length === 0) {
        return [];
      }

      const endpoint = `https://${shopDomain}/api/2024-01/graphql.json`;

      const query = `
        query getProductMetafields($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              highlights: metafield(namespace: "neo", key: "highlights") {
                value
              }
              tag: metafield(namespace: "neo", key: "usage_tag") {
                value
              }
            }
          }
        }
      `;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken
        },
        body: JSON.stringify({
          query,
          variables: {
            ids: productIds.map(id => `gid://shopify/Product/${id}`)
          }
        })
      });

      if (!response.ok) {
        throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
      }

      const responseData = await response.json();
      const { data, errors } = responseData;

      if (errors) {
        console.error("GraphQL errors:", errors);
        return [];
      }

      if (!data || !data.nodes || !Array.isArray(data.nodes)) {
        console.warn("Invalid GraphQL response structure");
        return [];
      }

      /**
       * Shopify guarantees:
       * nodes[] order === ids[] order
       */
      return data.nodes.map(node => {
        try {
          const highlights = node?.highlights?.value
            ? JSON.parse(node.highlights.value)
              .map(v => v?.trim())
              .filter(Boolean)
            : [];

          const tag = node?.tag?.value
            ? node.tag.value.trim()
            : "";

          return {
            highlights,
            tag
          };
        } catch (parseError) {
          console.warn('Error parsing metafield data for node:', parseError);
          return {
            highlights: [],
            tag: ""
          };
        }
      });
    } catch (error) {
      console.error('Error in fetchProductMetafields:', error);
      // Return empty array with same length as productIds to maintain order
      return productIds.map(() => ({
        highlights: [],
        tag: ""
      }));
    }
  }

  /**
     @param {string[]} highlights - Array of strings
     @param {Element} element - Element to hydrate
     @returns {void}
   */

  hydrateHighlights(highlights, element) {
    let highlightsText = highlights.join(" | ");
    element.textContent = highlightsText;
  }

  /**
   * Hydrate the tag for a given element
   * @param {string} tag - Tag to hydrate
   * @param {Element} element - Element to hydrate
   * @returns {void}
   */
  hydrateTag(tag, element) {
    if (tag) {
      element.textContent = tag;
    } else {
      element.style.display = 'none';
    }
  }
}

/* ----------------------------
   Initialization
----------------------------- */

window.customCartWishlistInstance = null;

function initializeWishlist() {
  const headerWishlistCountSpan = document.querySelector('[data-wishlist-count]');
  const wishlistContainer = document.querySelector('[data-wishlist-container]');
  const emptyStateDiv = document.querySelector('[data-wishlist-empty]');

  if(globalThis.wishlistItemsSTC?.forceEmpty === true){
    emptyStateDiv.classList.remove('is-hidden');
  }

  if (!headerWishlistCountSpan || !wishlistContainer) return;

  if (window.customCartWishlistInstance) {
    window.customCartWishlistInstance.init("Instance Already Exists, Then Initialize");
  } else {
    window.customCartWishlistInstance = new CustomCartWishlist(headerWishlistCountSpan, wishlistContainer, emptyStateDiv);
    window.customCartWishlistInstance.init("Create Instance, Then Initialize");
  }
}


/* ----------------------------
   SDK Readiness Guard
----------------------------- */

let sdkPollInterval = null;
let sdkPollStartTime = Date.now();
const SDK_MAX_WAIT = 30000; // 10 seconds safety cap

export function waitForWishlistSDK() {
  sdkPollInterval = setInterval(() => {
    if (typeof SWGetCustomerWishlistId === 'function') {
      clearInterval(sdkPollInterval);
      // SDK is ready → initialize wishlist
      initializeWishlist();
      // Note: ReloadSmartWishlist() will be called automatically after grid hydration
      // in hydrateWishlistContainer() method, only if cards are present and SDK is loaded

      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        cartDrawer.addEventListener('dialog:open', () => {
          initializeWishlist();

          // After drawer content re-renders, update the wishlist tab label again
          setTimeout(() => {
            if (window.customCartWishlistInstance && window.customCartWishlistInstance.state && window.customCartWishlistInstance.state.count != null) {
              window.customCartWishlistInstance.updateWishlistTabDisplay(globalThis.wishlistItemsSTC.items.length ?? 0, "Cart Drawer Open");
            }
          }, 300);
        });
      }
    }

    // Safety escape to avoid infinite loop
    if (Date.now() - sdkPollStartTime > SDK_MAX_WAIT) {
      clearInterval(sdkPollInterval);
      console.warn(
        'SmartWishlist SDK did not load within expected time.'
      );
    }
  }, 200);
}

/**
 * Sets up a listener for cart drawer re-rendering events
 * Re-initializes wishlist after cart drawer content is updated
 */
// function setupCartDrawerRerenderListener() {
//   // Also listen for custom cart:updated events from custom-cart-controllers
//   document.addEventListener('cart:updated', () => {
//     // Only re-initialize if SDK is ready
//     // if (typeof SWGetCustomerWishlistId === 'function') {
//       // Wait for morphing to complete before re-initializing
//       // setTimeout(() => {
//       //   if (window.customCartWishlistInstance) {
//       //     window.customCartWishlistInstance.init("cart:updated");
//       //   } else {
//       //     initializeWishlist();
//       //   }
//       // }, 100);

//     // }
//   });
// }

// Set up cart drawer re-render listener immediately
// setupCartDrawerRerenderListener();

// Ensure SmartWishlist SDK is ready before initializing wishlist
if (typeof waitForWishlistSDKAndCallMyFunction === 'function') {
  waitForWishlistSDKAndCallMyFunction(initializeWishlist);
} else {
  // Fallback to old polling if the global helper isn't present for some reason
  waitForWishlistSDK();
}

window.initializeWishlistInstance = initializeWishlist;